<template>
  <FormEdit
    :errors="errors"
    :fields="fields"
    model="herd-item"
    @submitted="update"
  >
    <div class="elr-form-row">
      <InputText
        label="Purchase Price (USD)"
        v-model="formData.price"
        fieldName="price"
        :errors="errors"
        :errorMessage="(errors && errors.price) ? errors.price[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
      <InputDate
        label="Purchase Date"
        v-model="formData.purchase_date"
        fieldName="purchase_date"
        :errors="errors"
        :errorMessage="(errors && errors.purchase_date) ? errors.purchase_date[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Condition"
        v-model="formData.condition"
        fieldName="condition"
        :errors="errors"
        :errorMessage="(errors && errors.condition) ? errors.condition[0] : null"
        :required=true
        :values="conditionsList"
      />
      <InputSelect
        label="Status"
        v-model="formData.status"
        fieldName="status"
        :errors="errors"
        :errorMessage="(errors && errors.status) ? errors.status[0] : null"
        :required=true
        :values="statusList"
      />
    </div>
    <!-- if status is listed -->
    <div v-if="formData.status === 'listed'" class="elr-form-row">
      <InputText
        label="Asking Price (USD)"
        v-model="formData.asking_price"
        fieldName="asking_price"
        :errors="errors"
        :errorMessage="(errors && errors.asking_price) ? errors.asking_price[0] : null"
        supportText="we recommend an asking price or slightly above purchase price to cover fees."
      />
    </div>
    <div v-if="formData.status === 'pending sale' || formData.status === 'sold'" class="elr-form-row">
      <InputText
        label="Sold to"
        v-model="formData.sold_to"
        fieldName="sold_to"
        :errors="errors"
        :errorMessage="(errors && errors.sold_to) ? errors.sold_to[0] : null"
        supportText="keeping track of who you're selling to can help if you ever need to follow up"
      />
      <InputText
        label="Sale Price (USD)"
        v-model="formData.sale_price"
        fieldName="sale_price"
        :errors="errors"
        :errorMessage="(errors && errors.sale_price) ? errors.sale_price[0] : null"
      />
    </div>
    <div v-if="formData.status === 'pending sale' || formData.status === 'sold'" class="elr-form-row">
      <InputDate
        label="Sold Date"
        v-model="formData.sold_date"
        fieldName="sold_date"
        :errors="errors"
        :errorMessage="(errors && errors.sold_date) ? errors.sold_date[0] : null"
      />
    </div>
    <!-- if status is sold or pending sale -->
    <div class="elr-form-row">
      <InputTextArea
        label="Notes"
        v-model="formData.notes"
        fieldName="notes"
      />
    </div>
  </FormEdit>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { validate } from '../../utils/validation';
import { currency, covertToPennies } from '../../utils/helpers';
import moment from 'moment';
// import { conditions, statuses } from '../../data/config';
import FormEdit from '../FormEdit/FormEdit';
import InputDate from '../InputDate/InputDate';
import InputText from '../InputText/InputText';
import InputTextArea from '../InputTextArea/InputTextArea';
import InputSelect from '../InputSelect/InputSelect';

export default {
  name: 'FormHerdItemEdit',
  props: {
    id: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        price: 0,
        condition: null,
        status: null,
        purchase_date: null,
        sold_to: null,
        sold_date: null,
        asking_price: 0,
        sale_price: 0,
        notes: null,
        mane_condition: null,
        tail_condition: null,
        pony_cancer: null,
        large_marks: null,
        scratches: null,
        hoof_condition: null,
        eye_condition: null,
        blush_condition: null,
        neck_seam_condition: null,
        rattling: null,
        symbols: null,
      },
      fields: [
        {
          name: 'price',
          label: 'Purchase Price',
          type: 'text',
          rules: 'required'
        },
        {
          name: 'condition',
          label: 'Condition',
          type: 'select',
          rules: 'required'
        },
        {
          name: 'status',
          label: 'Status',
          type: 'select',
          rules: 'required'
        },
        {
          name: 'purchase_date',
          label: 'Purchase Date',
          type: 'date',
          rules: 'required'
        },
        {
          name: 'sold_to',
          label: 'Sold To',
          type: 'text',
          // rules: 'integer'
        },
        {
          name: 'sold_date',
          label: 'Sold Date',
          type: 'date',
          // rules: ''
        },
        {
          name: 'asking_price',
          label: 'Asking Price',
          type: 'text',
          // rules: 'integer'
        },
        {
          name: 'sale_price',
          label: 'Sale Price',
          type: 'text',
          // rules: 'integet'
        },
        {
          name: 'notes',
          label: 'Notes',
          type: 'textarea',
          // rules: ''
        },
      ]
    };
  },
  components: {
    FormEdit,
    InputText,
    InputTextArea,
    InputSelect,
    InputDate
  },
  mounted() {
    this.populateForm();
  },
  computed: {
    ...mapState('herdItem', ['conditions', 'statuses']),
    conditionsList() {
      return this.conditions.map(o => {
        return { value: o.id, label: o.name };
      });
    },
    statusList() {
      return this.statuses.map(o => {
        return { value: o.id, label: o.name };
      });
    },
    errors() {
      return {}
      // return (this.$store && this.$store.state.herdItem.errors) ? this.$store.state.herdItem.errors[0] : {};
    }
  },
  methods: {
    ...mapActions('herdItem', ['UPDATE', 'SET_ERROR', 'RESET_ERRORS']),
    populateForm() {
      const price = (typeof this.item.price === 'number') ? currency(this.item.price) : this.item.price;
      const asking_price = (typeof this.item.asking_price === 'number') ? currency(this.item.asking_price) : this.item.asking_price;
      const sale_price = (typeof this.item.sale_price === 'number') ? currency(this.item.sale_price) : this.item.sale_price;

      this.formData = Object.assign({
        herd_id: this.item.herd_id,
        collectible_id: this.item.pony_id
      }, {
        price,
        condition: this.item.condition,
        status: this.item.status,
        purchase_date: this.item.purchase_date ? moment(this.item.purchase_date).format("YYYY-MM-DD") : null,
        sold_to: this.item.sold_to,
        sold_date: this.item.sold_date ? moment(this.item.sold_date).format("YYYY-MM-DD") : null,
        asking_price,
        sale_price,
        notes: this.item.notes,
      });
    },
    validate(data) {
      const errors = validate(this.fields, data);

      if (this.hasErrors(errors)) {
        this.SET_ERROR({ errors });
        this.$emit('error', { errors });

        return true
      }

      return false;
    },
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    },
    resetForm() {
      this.populateForm();
    },
    update() {
      if (this.validate(this.formData)) {
        return;
      }

      // * convert price to pennies
      this.formData.price = covertToPennies(this.formData.price);
      this.formData.asking_price = covertToPennies(this.formData.asking_price);
      this.formData.sale_price = covertToPennies(this.formData.sale_price);

      this.UPDATE({
        id: this.item.id,
        formData: this.formData
      });
      this.RESET_ERRORS();
      this.$emit('submitted', { data: this.formData });
    }
  },
  watch: {
    // item() {
    //   this.populateForm();
    // }
  }
};
</script>
